"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalServiceStub = void 0;
class ApprovalServiceStub {
    async getApprovalConfig(_companyId) {
        return { status: true, message: "Approval config retrieved", payload: {} };
    }
    async setApprovalConfig(_companyId, config) {
        return { status: true, message: "Approval config updated", payload: config };
    }
    async getUserRoles(_companyId) {
        return {
            status: true,
            message: "User roles retrieved",
            payload: { admins: [], approvers: [], activeApproverCount: 0 },
        };
    }
    async updateUserRoles(_companyId, userId, roles) {
        return { status: true, message: "User roles updated", payload: { userId, roles } };
    }
    async approveAndExecute(requestId) {
        return { status: true, message: "Approved", payload: { requestId, executed: true } };
    }
    async getApproval(requestId) {
        return {
            status: true,
            message: "Approval retrieved",
            payload: {
                requestId,
                companyId: "",
                actionType: "",
                actionRef: "",
                fundName: "",
                summary: "",
                requester: "",
                requestedAt: new Date().toISOString(),
                state: "pending",
                canApprove: false,
                canCancel: false,
                notifiedApproverIds: [],
                reviewedPayload: {},
            },
        };
    }
    async listPendingApprovals(_companyId) {
        return { status: true, message: "Pending approvals retrieved", payload: [] };
    }
    async listRejectedApprovals(_companyId) {
        return { status: true, message: "Rejected approvals retrieved", payload: [] };
    }
    async rejectApproval(requestId, reason) {
        return {
            status: true,
            message: "Rejected",
            payload: {
                actionRef: requestId,
                approvalState: "draft",
                rejectionNote: { reason: reason ?? "", rejectedBy: "", rejectedAt: new Date().toISOString() },
                notificationSent: true,
            },
        };
    }
    async cancelApproval(requestId) {
        return { status: true, message: "Cancelled", payload: { actionRef: requestId, approvalState: "draft" } };
    }
    async resubmitAction(_companyId, _actionType, actionRef, _payload, _files) {
        return {
            status: true,
            message: "Resubmitted",
            payload: { requestId: "", actionRef, state: "pending", notifiedApproverIds: [], link: "" },
        };
    }
    async deleteRejectedDraft(_companyId, _actionType, _actionRef) {
        return { status: true, message: "Deleted", payload: { deleted: true } };
    }
    async getPendingApprovalCount(_companyId) {
        return { status: true, message: "Count retrieved", payload: { count: 0 } };
    }
    async notifyApprovers(_requestId, approverUserId) {
        return {
            status: true,
            message: "Approver notified",
            payload: { notifiedCount: 1, approverUserId, alreadyNotified: false, notifiedApproverIds: [approverUserId] },
        };
    }
    async getRejectedDraft(_companyId, _actionType) {
        return { status: true, message: "Rejected draft retrieved", payload: null };
    }
}
exports.ApprovalServiceStub = ApprovalServiceStub;
//# sourceMappingURL=ApprovalServiceStub.js.map